import { createSlice } from '@loopbound-ares/microfrontend';
import { AuthorizePage } from './authorize';

export let productSlice = createSlice([
  {
    path: 'authorize',
    element: <AuthorizePage />
  }
]);
